import { DEFAULT_AXIS_FONT_SIZE } from "constants/chart.constants";
import { EvaChart } from "constants/charts.enums";
import { THEME_FONT_FAMILY } from "constants/style.constants";
import { EChartsOption } from "echarts";
import { createStateWithDefaults } from "entities/utils";

import { DEFAULT_TITLE_OPTIONS } from "./title";
import { DEFAULT_X_AXIS_OPTIONS } from "./xAxis";
import { DEFAULT_Y_AXIS_OPTIONS } from "./yAxis";

export const DEFAULT_CHART_OPTIONS: Partial<EChartsOption> = {
  backgroundColor: "",
  progressive: 400,
  progressiveThreshold: 3000,
  toolbox: {
    orient: "vertical",
    itemSize: 13,
    top: 15,
    right: -6,
    emphasis: null,
    feature: {
      dataZoom: {
        yAxisIndex: "all",

        icon: {
          zoom: "path://",
          back: "path://"
        },
        brushStyle: {
          borderWidth: 1,
          color: "rgba(24, 144, 255, 0.15)",
          borderColor: "rgba(24, 144, 255, 0.45)"
        }
      },
      brush: {
        type: ["rect", "polygon", "lineX", "lineY", "keep", "clear"],
        icon: {
          rect: "path://",
          polygon: "path://",
          lineX: "path://",
          lineY: "path://",
          keep: "path://",
          clear: "path://"
        },
        title: {
          rect: "",
          polygon: "",
          lineX: "",
          lineY: "",
          keep: "",
          clear: ""
        }
      }
    }
  },
  brush: {
    brushType: "polygon",
    throttleType: "debounce",
    throttleDelay: 100,
    xAxisIndex: 0,
    toolbox: ["rect", "polygon", "lineX", "lineY", "keep", "clear"]
  },
  title: DEFAULT_TITLE_OPTIONS,
  textStyle: {
    fontFamily: THEME_FONT_FAMILY,
    fontSize: DEFAULT_AXIS_FONT_SIZE,
    color: "#041C2C"
  },
  yAxis: DEFAULT_Y_AXIS_OPTIONS,
  xAxis: DEFAULT_X_AXIS_OPTIONS,
  graphic: [],
  animation: false,
  grid: {
    left: 70,
    bottom: 50,
    top: 50,
    right: 20
  },
  uwiList: [],
  uwiCoordinates: {},
  // tooltip: { // DO NOT SET IT HERE, IT WILL BE SET IN THE TRANSLATOR
  //   trigger: "axis",
  //   confine: true,
  //   enterable: true,
  //   className: "chart-tooltip-container",
  //   extraCssText: "border-style:none;",

  //   axisPointer: {
  //     type: "cross",
  //     label: {
  //       show: true
  //     }
  //   }
  // },
  dataZoom: [
    {
      type: "slider",
      id: "xAxis-slider",
      xAxisIndex: 0,
      filterMode: "none",
      backgroundColor: "rgba(0,0,0,0)",
      fillerColor: "rgba(0,0,0,0)",
      handleSize: "14px",
      handleIcon: "path://M0 0L3 0L3 14L0 14L0 0Z",
      handleStyle: {
        opacity: 1,
        color: "#cdd2d5"
      },
      borderColor: "rgba(0,0,0,0)",
      showDataShadow: false,
      showDetail: false,
      moveHandleSize: 0,
      moveHandleStyle: {
        borderWidth: 0,
        opacity: 1
      },
      zlevel: -1,
      bottom: 32,
      brushSelect: false,
      height: "21px",
      show: true
    },
    {
      type: "slider",
      id: "yAxis-slider",
      yAxisIndex: 0,
      filterMode: "none",
      backgroundColor: "rgba(0,0,0,0)",
      fillerColor: "rgba(0,0,0,0)",
      handleSize: "14px",
      handleIcon: "path://M0 0L3 0L3 14L0 14L0 0Z",
      handleStyle: {
        opacity: 1,
        color: "#cdd2d5"
      },
      borderColor: "rgba(0,0,0,0)",
      showDataShadow: false,
      showDetail: false,
      moveHandleSize: 0,
      moveHandleStyle: {
        borderWidth: 0,
        opacity: 1
      },
      left: 50,
      zlevel: -1,
      brushSelect: false
    },
    {
      type: "inside",
      orient: "vertical",
      filterMode: "none"
      // throttle: 0
    },
    {
      type: "inside",
      filterMode: "none",
      orient: "horizontal"
      // throttle: 0 // TODO chart: need to play with it more to get the right value (https://echarts.apache.org/en/option.html#dataZoom-inside.throttle)
    }
  ],
  // series: [], // DO NOT SET IT HERE, IT WILL BE SET IN THE TRANSLATOR
  //   /* A large dataset may require that we stop hovered elements from being rendered in a seperate layer,
  //    * to avoid visual issues of other elements rendering (when hovering).
  //    * It seems that we do need to repaint the canvas when hovering, so we set the threshold to Infinity
  //    * https://echarts.apache.org/en/option.html#hoverLayerThreshold
  //    */
  hoverLayerThreshold: Infinity,
  // custom options
  chartType: EvaChart.CrossPlot,
  extends: {
    xMin: undefined,
    xMax: undefined,
    yMin: undefined,
    yMax: undefined
  }
};

export const generateChartOptions = createStateWithDefaults(DEFAULT_CHART_OPTIONS);
